export default __webpack_public_path__ + "static/media/KoshikeSaikumar.5ec952c5.pdf";